var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Carousel',{staticClass:"images_home",attrs:{"images":_vm.images}})}
var staticRenderFns = []

export { render, staticRenderFns }